/**
 * Component Registry for Email Builder Blocks
 * 
 * This registry pattern breaks circular dependencies by allowing blocks to
 * register themselves at runtime, rather than requiring static imports.
 */

const registry = new Map();

/**
 * Register a component with the registry
 * @param {string} name - Unique identifier for the component
 * @param {React.Component} component - The component to register
 */
function register(name, component) {
    registry.set(name, component);
}

/**
 * Get a component from the registry
 * @param {string} name - The identifier of the component to retrieve
 * @returns {React.Component|undefined} The registered component or undefined
 */
function get(name) {
    return registry.get(name);
}

/**
 * Check if a component is registered
 * @param {string} name - The identifier to check
 * @returns {boolean}
 */
function has(name) {
    return registry.has(name);
}

/**
 * Get all registered component names
 * @returns {string[]}
 */
function getRegisteredNames() {
    return Array.from(registry.keys());
}

const ComponentRegistry = {
    register,
    get,
    has,
    getRegisteredNames
};

export default ComponentRegistry;

